import axios from "axios";
import { Constants } from "../utils/Constants";

const BASE_URL = `${Constants.baseUrl}/colaboradores`;

export const getDataTable = (event) => axios.post(`${BASE_URL}/list`, event);

export const simpleList = (event) => axios.get(`${BASE_URL}/simpleList`);

export const get = (id) => axios.get(`${BASE_URL}/${id}`);

export const create = (data) => axios.post(BASE_URL, data);

export const update = (data, id) => axios.put(`${BASE_URL}/${id}`, data);

export const destroy = (id) => axios.delete(`${BASE_URL}/${id}`);
